import styled from 'styled-components';

const PopupStyle = styled.div`
	--popupPadding: var(--sp5x);
	--popupContentMaxWidth: var(--sp163x);
	--popupContentMaxHeight: 100vh;
	--closeButtonSizes: var(--sp7x);
	--closeIconSize: var(--pS);

	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 100vh;
	width: 100vw;
	z-index: 100000;

	&::-webkit-scrollbar {
		display: none;
	}

	&.active {
		pointer-events: all;
		opacity: 1;
		z-index: 1000;
	}

	.popup-background {
		background-color: #000;
		opacity: 30%;
		pointer-events: all;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.popup-content-container {
		max-width: var(--popupContentMaxWidth);
		max-height: var(--popupContentMaxHeight);
		display: flex;
		align-items: center;
		width: 100%;
		height: 100vh;
		pointer-events: all;
		overflow-x: hidden;
		overflow-y: scroll;
		margin: auto;
		-ms-overflow-style: none;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		.popup-content-wrap {
			position: relative;
			width: 100%;
			height: fit-content;
			max-height: 95%;
			padding: var(--popupPadding);
			background: white;
			border-radius: var(--sp3x);
			opacity: 1;
			overflow-x: hidden;
			overflow-y: scroll;
			-ms-overflow-style: none;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}

			.close {
				display: flex;
				justify-content: center;
				align-items: center;
				position: sticky;
				top: 0;
				width: var(--closeButtonSizes);
				height: var(--closeButtonSizes);
				background-color: var(--secondaryColor4);
				margin-left: auto;
				color: red;
				border-radius: var(--sp2x);
				cursor: pointer;
				z-index: 2;

				.close-btn-icon {
					color: var(--primaryColor1);
					font-size: var(--closeIconSize);
				}
			}
		}
	}
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--popupPadding: var(--sp4x);
		--popupContentMaxWidth: var(--sp126x);
		--closeButtonSizes: var(--sp6x);

		.popup-content-container {
			.popup-content-wrap {
				.close {
					border-radius: var(--sp1-5x);
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--popupPadding: var(--sp3x);
		--popupContentMaxWidth: var(--sp101x);
		--closeButtonSizes: var(--sp5x);

		.popup-content-container {
			.popup-content-wrap {
				.close {
					border-radius: var(--sp1-5x);
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--popupPadding: var(--sp3x);
		--popupContentMaxWidth: var(--sp95x);
		--closeButtonSizes: var(--sp5x);

		.popup-content-container {
			.popup-content-wrap {
				.close {
					border-radius: var(--sp1-5x);
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--popupPadding: var(--sp3x);
		--popupContentMaxWidth: var(--sp93x);
		--closeButtonSizes: var(--sp5x);

		.popup-content-container {
			.popup-content-wrap {
				.close {
					border-radius: var(--sp1-5x);
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--popupPadding: var(--sp3x);
		--popupContentMaxWidth: var(--sp87x);
		--closeButtonSizes: var(--sp5x);

		.popup-content-container {
			.popup-content-wrap {
				.close {
					border-radius: var(--sp1-5x);
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--popupPadding: var(--sp3x);
		--popupContentMaxWidth: var(--sp81x);
		--closeButtonSizes: var(--sp5x);

		.popup-content-container {
			.popup-content-wrap {
				.close {
					border-radius: var(--sp1-5x);
				}
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--popupContentMaxWidth: 100%;
		--popupContentMaxHeight: 100vh;
		--popupPadding: var(--sp3x);
		--closeButtonSizes: var(--sp5x);

		.popup-content-container {
			height: 100vh;

			.popup-content-wrap {
				.close {
					border-radius: var(--sp1-5x);
				}
			}
		}
	}
`;
export default PopupStyle;
